import { GameConstants } from "../../GameConstants";

import { GameVars } from "../../GameVars";
import { MazeCursor } from "./MazeCursor";
import { Goal } from "./Goal";

export class MazeContainer extends Phaser.GameObjects.Container {

    public static currentInstance: MazeContainer;

    private static OFFSET_FOR_RENDERTEXTURE: number = 256; // render texture cuts off top and left margins otherwise
    private static WALL_WIDTH_MULTIPLIER: number = 1.4;

    public mazeCursor: MazeCursor;
    public goal: Goal;
    public dx: number;
    public dy: number;

    private gridTileMap: Phaser.GameObjects.TileSprite;
    private mazeWallsGraphics: Phaser.GameObjects.Graphics;
    private pathGraphics: Phaser.GameObjects.Graphics;
    private extraTimePowerUp: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {

        super(scene);

        MazeContainer.currentInstance = this;

        const tileFrameName = this.getLevelTileName();

        this.gridTileMap = new Phaser.GameObjects.TileSprite(this.scene, 0, 0, GameConstants.GAME_WIDTH + GameVars.l, GameConstants.GAME_HEIGHT + GameVars.l * 2, "texture_atlas_1", tileFrameName);
        this.add(this.gridTileMap);

        this.pathGraphics = new Phaser.GameObjects.Graphics(this.scene);
        this.add(this.pathGraphics);

        this.drawMazeWalls();

        // walls render texture
        if (this.scene.textures.exists("walls")) {
            this.scene.textures.remove("walls");
        }
        this.mazeWallsGraphics.generateTexture("walls", GameConstants.GAME_WIDTH + MazeContainer.OFFSET_FOR_RENDERTEXTURE,
            GameConstants.GAME_HEIGHT + MazeContainer.OFFSET_FOR_RENDERTEXTURE);
        const wallsRenderTexture = new Phaser.GameObjects.Image(this.scene, 0, 0, "walls");
        wallsRenderTexture.setOrigin(0, 0);
        this.add(wallsRenderTexture);
        this.mazeWallsGraphics.destroy();

        this.addGoal();

        const wallsRenderTextureX = -this.dx - MazeContainer.OFFSET_FOR_RENDERTEXTURE;
        const wallsRenderTextureY = -this.dy - MazeContainer.OFFSET_FOR_RENDERTEXTURE;
        const gridRenderTextureX = -this.dx + GameConstants.GAME_WIDTH * .5 - GameVars.l;
        const gridRenderTextureY = -this.dy + GameConstants.GAME_HEIGHT * .5 - GameVars.l * 2.5;

        wallsRenderTexture.setPosition(wallsRenderTextureX, wallsRenderTextureY);
        this.gridTileMap.setPosition(gridRenderTextureX, gridRenderTextureY);

        this.addCursor();

        this.addPowerUps();

        // HAY Q HACER ESTO PQ EL METODO UPDATE NO SE UTILIZA DE MANERA AUTOMATICA
        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        if (!this.mazeCursor.moving) {
            return;
        }

        const lineWidth = 5;

        let colorPath = GameConstants.COLOR_NONE;

        // dibujar el path
        if (GameVars.movingBackwards || GameVars.justChangedDirection) {
            this.pathGraphics.clear();
        }

        this.pathGraphics.lineStyle(lineWidth, colorPath);
        this.pathGraphics.beginPath();

        let p1x: number;
        let p1y: number;

        let p2x: number;
        let p2y: number;

        let ii: number;
        let iii: number;

        if (GameVars.movingBackwards && this.mazeCursor.moving) {
            ii = GameVars.path.length - 2;
            iii = GameVars.path.length - 1;
        } else {
            ii = GameVars.path.length - 1;
            iii = GameVars.path.length;
        }

        for (let i = GameVars.justChangedDirection || GameVars.movingBackwards ? 0 : GameVars.path.length - 2; i < ii; i++) {

            p1x = (GameVars.path[i].c + .5) * GameVars.l - this.dx;
            p1y = (GameVars.path[i].r + .5) * GameVars.l - this.dy;

            p2x = (GameVars.path[i + 1].c + .5) * GameVars.l - this.dx;
            p2y = (GameVars.path[i + 1].r + .5) * GameVars.l - this.dy;

            this.pathGraphics.moveTo(p1x, p1y);
            this.pathGraphics.lineTo(p2x, p2y);
        }

        this.pathGraphics.moveTo(p2x, p2y);
        this.pathGraphics.lineTo(this.mazeCursor.x, this.mazeCursor.y);

        this.pathGraphics.strokePath();

        this.pathGraphics.fillStyle(colorPath);

        // dibujar un cuadrado en cada nodo
        for (let i = GameVars.justChangedDirection || GameVars.movingBackwards ? 0 : GameVars.path.length - 2; i < iii; i++) {

            const x = (GameVars.path[i].c + .5) * GameVars.l - this.dx - lineWidth * .5;
            const y = (GameVars.path[i].r + .5) * GameVars.l - this.dy - lineWidth * .5;

            this.pathGraphics.fillRect(x, y, lineWidth, lineWidth);
        }

        GameVars.justChangedDirection = false;
    }

    public bringGridToFront(): void {

        this.bringToTop(this.gridTileMap);
    }

    public sendGridToBack(): void {

        this.sendToBack(this.gridTileMap);
    }

    public extraTime(): void {

        this.extraTimePowerUp.destroy();
    }

    public lastTween(): void {

        this.scene.tweens.add({
            targets: this,
            scaleX: 1.4,
            scaleY: 1.4,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 500
        });
    }

    public gameOver(): void {

        this.mazeCursor.gameOver();

        this.scene.tweens.add({
            targets: this.pathGraphics,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1650
        });
    }

    public mazeSolved() {

        this.goal.mazeSolved();
    }

    private drawMazeWalls(): void {

        const colours = GameVars.getLevelColours(GameVars.levelColourId);

        this.mazeWallsGraphics = new Phaser.GameObjects.Graphics(this.scene);
        this.add(this.mazeWallsGraphics);

        for (let r = 0; r < GameVars.rows; r++) {
            for (let c = 0; c < GameVars.cols; c++) {
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.inner, 8, .025, -2.5, -2.5);
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.outer, 8 * .5, .025, -2.5, -2.5);
            }
        }

        for (let r = 0; r < GameVars.rows; r++) {
            for (let c = 0; c < GameVars.cols; c++) {
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.inner, 8, .025, -2.5, 2.5);
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.outer, 8 * .5, .025, -2.5, 2.5);
            }
        }

        for (let r = 0; r < GameVars.rows; r++) {
            for (let c = 0; c < GameVars.cols; c++) {
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.inner, 8, .025, 2.5, -2.5);
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.outer, 8 * .5, .025, 2.5, -2.5);
            }
        }

        for (let r = 0; r < GameVars.rows; r++) {
            for (let c = 0; c < GameVars.cols; c++) {
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.inner, 8, .025, 2.5, 2.5);
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.outer, 8 * .5, .025, 2.5, 2.5);
            }
        }

        //////////////
        for (let r = 0; r < GameVars.rows; r++) {
            for (let c = 0; c < GameVars.cols; c++) {
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.inner, 6, .075, -1.5, -1.5);
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.outer, 6 * .5, .075, -1.5, -1.5);
            }
        }

        for (let r = 0; r < GameVars.rows; r++) {
            for (let c = 0; c < GameVars.cols; c++) {
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.inner, 6, .075, -1.5, 1.5);
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.outer, 6 * .5, .075, -1.5, 1.5);
            }
        }

        for (let r = 0; r < GameVars.rows; r++) {
            for (let c = 0; c < GameVars.cols; c++) {
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.inner, 6, .075, 1.5, -1.5);
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.outer, 6 * .5, .075, 1.5, -1.5);
            }
        }

        for (let r = 0; r < GameVars.rows; r++) {
            for (let c = 0; c < GameVars.cols; c++) {
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.inner, 6, .075, 1.5, 1.5);
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.outer, 6 * .5, .075, 1.5, 1.5);
            }
        }

        // ESTA ES LA PARED CENTRAL
        for (let r = 0; r < GameVars.rows; r++) {
            for (let c = 0; c < GameVars.cols; c++) {
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.inner, 4.5, 1, 0, 0);
                this.drawCell(r, c, GameVars.maze.repr[r][c], colours.outer, 4.5 * .5, 1, 0, 0);
            }
        }
    }

    private getLevelTileName(): string {

        if (GameVars.currentLevel < 6) {
            return "bg_grid_1";
        } else if (GameVars.currentLevel < 11) {
            return "bg_grid_2";
        } else if (GameVars.currentLevel < 16) {
            return "bg_grid_3";
        } else if (GameVars.currentLevel < 21) {
            return "bg_grid_4";
        } else {
            return "bg_grid_5";
        }
    }

    private addGoal(): void {

        this.dx = (GameVars.goalPosition.c + .5) * GameVars.l;
        this.dy = (GameVars.goalPosition.r + .5) * GameVars.l;

        this.goal = new Goal(this.scene);
        this.add(this.goal);

        // cambiamos la posicion para poder hacer un ZOOM
        this.x = (GameConstants.GAME_WIDTH - GameVars.l * GameVars.cols) * .5 + this.dx;
        this.y = 70 + this.dy;
    }

    private addCursor(): void {

        this.mazeCursor = new MazeCursor(this.scene);
        this.mazeCursor.x = (GameVars.cursorPosition.c + .5) * GameVars.l - this.dx;
        this.mazeCursor.y = (GameVars.cursorPosition.r + .5) * GameVars.l - this.dy;
        this.add(this.mazeCursor);
    }

    private addPowerUps(): void {

        if (GameVars.extraTimePosition !== null) {

            const px = (GameVars.extraTimePosition.c + .5) * GameVars.l - this.dx;
            const py = (GameVars.extraTimePosition.r + .5) * GameVars.l - this.dy;

            this.extraTimePowerUp = new Phaser.GameObjects.Image(this.scene, px, py, "texture_atlas_1", "icon_time_ingame_powerup");
            this.extraTimePowerUp.setOrigin(.5);
            this.extraTimePowerUp.setScale(.5, GameVars.scaleY * .5);
            this.add(this.extraTimePowerUp);

            this.scene.tweens.add({
                targets: this.extraTimePowerUp,
                scaleX: .6,
                scaleY: .6 * GameVars.scaleY,
                ease: Phaser.Math.Easing.Cubic.InOut,
                repeat: -1,
                yoyo: true,
                duration: 250
            });


        } else {
            this.extraTimePowerUp = null;
        }
    }

    private drawCell(r: number, c: number, value: number, color: number, width: number, alpha: number, dx: number, dy: number): void {

        this.mazeWallsGraphics.lineStyle(width * MazeContainer.WALL_WIDTH_MULTIPLIER, color, alpha);
        this.mazeWallsGraphics.beginPath();

        const px = c * GameVars.l + dx + MazeContainer.OFFSET_FOR_RENDERTEXTURE;
        const py = r * GameVars.l + dy + MazeContainer.OFFSET_FOR_RENDERTEXTURE;

        switch (value) {
            case 0:
                // nada
                break;
            case 1:
                this.mazeWallsGraphics.moveTo(px, py);
                this.mazeWallsGraphics.lineTo(px, py + GameVars.l);
                break;

            case 2:
                this.mazeWallsGraphics.moveTo(px, py + GameVars.l);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py + GameVars.l);
                break;

            case 3:
                this.mazeWallsGraphics.moveTo(px, py);
                this.mazeWallsGraphics.lineTo(px, py + GameVars.l);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py + GameVars.l);
                break;

            case 4:
                this.mazeWallsGraphics.moveTo(px + GameVars.l, py);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py + GameVars.l);
                break;

            case 5:
                this.mazeWallsGraphics.moveTo(px, py);
                this.mazeWallsGraphics.lineTo(px, py + GameVars.l);

                this.mazeWallsGraphics.moveTo(px + GameVars.l, py);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py + GameVars.l);

                break;

            case 6:
                this.mazeWallsGraphics.moveTo(px + GameVars.l, py);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py + GameVars.l);
                this.mazeWallsGraphics.lineTo(px, py + GameVars.l);

                break;

            case 7:
                this.mazeWallsGraphics.moveTo(px, py);
                this.mazeWallsGraphics.lineTo(px, py + GameVars.l);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py + GameVars.l);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py);

                break;

            case 8:
                this.mazeWallsGraphics.moveTo(px, py);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py);
                break;

            case 9:
                this.mazeWallsGraphics.moveTo(px, py + GameVars.l);
                this.mazeWallsGraphics.lineTo(px, py);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py);

                break;

            case 10:
                this.mazeWallsGraphics.moveTo(px, py);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py);

                this.mazeWallsGraphics.moveTo(px, py + GameVars.l);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py + GameVars.l);

                break;

            case 11:
                this.mazeWallsGraphics.moveTo(px + GameVars.l, py);
                this.mazeWallsGraphics.lineTo(px, py);
                this.mazeWallsGraphics.lineTo(px, py + GameVars.l);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py + GameVars.l);

                break;

            case 12:
                this.mazeWallsGraphics.moveTo(px, py);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py + GameVars.l);

                break;

            case 13:
                this.mazeWallsGraphics.moveTo(px, py + GameVars.l);
                this.mazeWallsGraphics.lineTo(px, py);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py + GameVars.l);

                break;

            case 14:
                this.mazeWallsGraphics.moveTo(px, py);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py);
                this.mazeWallsGraphics.lineTo(px + GameVars.l, py + GameVars.l);
                this.mazeWallsGraphics.lineTo(px, py + GameVars.l);

                break;

            default:
                break;
        }

        this.mazeWallsGraphics.strokePath();
    }
}
